// Periode d'une frise d'orchestration : "N derniers jours" (1/3/7) ou plage de CYCLES choisie
// (date de debut D1 et de fin D2 = from D1 19:00, to D2 19:00). Logique pure, sans React.
import { libelleJour } from "./frise";

export const JOURS_PERIODE = [1, 3, 7];
export const JOURS_DEFAUT = 3;
export const MAX_CYCLES = 7;
export const HEURE_CYCLE = "19:00";

const RE = /^\d{4}-\d{2}-\d{2}$/;
const p2 = (n) => String(n).padStart(2, "0");
const jourMs = (s) => Date.UTC(Number(s.slice(0, 4)), Number(s.slice(5, 7)) - 1, Number(s.slice(8, 10)));
const enChaine = (ms) => new Date(ms).toISOString().slice(0, 10);

export const dateValide = (s) => typeof s === "string" && RE.test(s) && enChaine(jourMs(s)) === s;
export const ajouterJours = (s, n) => enChaine(jourMs(s) + n * 86400000);
export const ecartJours = (a, b) => Math.round((jourMs(b) - jourMs(a)) / 86400000);
// date locale du jour au format YYYY-MM-DD
export const aujourdhui = (now = new Date()) => `${now.getFullYear()}-${p2(now.getMonth() + 1)}-${p2(now.getDate())}`;
const enDate = (s) => new Date(Number(s.slice(0, 4)), Number(s.slice(5, 7)) - 1, Number(s.slice(8, 10)));

// Periode lue dans l'URL : plage valide (from/to) prioritaire, sinon days (1/3/7), sinon 3 jours.
export function lirePeriode(params) {
  const p = params || {};
  if (dateValide(p.from) && dateValide(p.to) && ecartJours(p.from, p.to) > 0) {
    return { mode: "range", from: p.from, to: p.to };
  }
  const n = Number(p.days);
  return { mode: "days", days: JOURS_PERIODE.includes(n) ? n : JOURS_DEFAUT };
}

// Parametres d'API : days seul, ou from/to (exclusifs).
export const paramsApi = (periode) =>
  periode.mode === "range"
    ? { from: `${periode.from}T${HEURE_CYCLE}`, to: `${periode.to}T${HEURE_CYCLE}` }
    : { days: periode.days };

export const clePeriode = (periode) => (periode.mode === "range" ? `r:${periode.from}|${periode.to}` : `d:${periode.days}`);

// null si la plage est acceptable, sinon le message d'erreur.
export function validerPlage(d1, d2, { oldest, today } = {}) {
  if (!dateValide(d1) || !dateValide(d2)) return "Dates invalides";
  const n = ecartJours(d1, d2);
  if (n <= 0) return "La date de fin doit suivre la date de début";
  if (n > MAX_CYCLES) return `${MAX_CYCLES} cycles au plus`;
  if (today && d2 > today) return "Pas de date future";
  if (oldest && d1 < oldest) return "Antérieur aux données disponibles";
  return null;
}

export const decalerPlage = (d1, d2, n) => ({ from: ajouterJours(d1, n), to: ajouterJours(d2, n) });
export const premierJour = (v) => (typeof v === "string" && v.length >= 10 && dateValide(v.slice(0, 10)) ? v.slice(0, 10) : null);

// « du mar. 28/10 19 h au mer. 29/10 19 h »
export const titrePlage = (d1, d2) => `du ${libelleJour(enDate(d1))} 19 h au ${libelleJour(enDate(d2))} 19 h`;

// Nombre de jours de la fenetre (pas des graduations) : days, ou ecart from/to en mode plage.
export function nbJoursFenetre(periode, data) {
  if (periode.mode === "range") return Math.max(1, ecartJours(periode.from, periode.to));
  return (data && data.days) || periode.days;
}
